module.exports = __webpack_public_path__ + "img/HershOmer-PenjKatzhimer.84a47e58.jpg";